import React from 'react';
import { Camera } from 'lucide-react';

const Hero = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <section
      id="home"
      className="relative h-screen flex items-center justify-center text-white overflow-hidden"
    >
      {/* Background Image with Overlay */}
      <div className="absolute inset-0">
        <img
          src="/assets/live_music/AA2_6987.jpg"
          alt="Concert Photography"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-pink-900/70 via-pink-800/50 to-gray-900/70"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 text-center px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto">
        <div className="mb-6 inline-block">
          <Camera size={64} className="text-white opacity-90" />
        </div>
        
        <p className="text-lg sm:text-xl md:text-2xl font-light tracking-wide mb-4 text-gray-200">
          Concert & Music Photography Specialist
        </p>
        
        <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold mb-6 leading-tight">
          Capturing Your Music in Motion
        </h1>
        
        <p className="text-lg sm:text-xl md:text-2xl font-light mb-12 text-gray-300 max-w-3xl mx-auto">
          Specializing in concert and music photography, with expertise in portraits, headshots, and special events
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <button
            onClick={() => scrollToSection('contact')}
            className="px-8 py-4 bg-pink-500 text-white font-semibold rounded-md hover:bg-pink-600 transition-all transform hover:scale-105 shadow-lg"
          >
            Book a Session
          </button>
          <button
            onClick={() => scrollToSection('portfolio')}
            className="px-8 py-4 bg-transparent border-2 border-white text-white font-semibold rounded-md hover:bg-white hover:text-pink-600 transition-all transform hover:scale-105"
          >
            View My Work
          </button>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-white rounded-full flex items-start justify-center p-2">
          <div className="w-1 h-3 bg-white rounded-full"></div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
